import React, { useCallback } from 'react';
import { injectIntl} from 'react-intl';

import {
  Form,
  Modal,
  Input
} from 'antd';

import './style.less';

const AddCompanyForm = ({
  intl,
  visible,
  setVisibility,
  onAddCompany,
  ...props
}) => {
  const t = intl.messages;
  const [form] = Form.useForm();
  const { validateFields } = form;

  const onAdd = useCallback(
    () => {
      validateFields().then(() => {
        const {name, url} = form.getFieldsValue();
        onAddCompany({name, url});
        form.setFieldsValue({name: '', url: ''});
        setVisibility(false);
      });
    },
    [validateFields, form, onAddCompany, setVisibility]
  );

  return (
    <Modal
      title={t.add_a_competitor}
      visible={visible}
      okText={t.add}
      onOk={onAdd}
      onCancel={() => setVisibility(false)}
    >
      <Form form={form}>
        <Form.Item
          label={t.name}
          name='name'
          rules={[{
            required: true,
            message: t.input_company_name,
          }]}
        >
          <Input placeholder={ t.company_name } />
        </Form.Item>
        <Form.Item
          label="URL"
          name='url'
          rules={[{
            required: false,
            message: t.input_company_name,
          }, {
            type: 'url',
            message: t.form_error_invalid_url,
          }]}
        >
          <Input placeholder="URL" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default injectIntl(AddCompanyForm);
